import { render, staticRenderFns } from "./ListPurchaseSaleBook.vue?vue&type=template&id=7844c1b4&lang=pug&"
import script from "./ListPurchaseSaleBook.vue?vue&type=script&lang=js&"
export * from "./ListPurchaseSaleBook.vue?vue&type=script&lang=js&"
import style0 from "./ListPurchaseSaleBook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ListPurchaseSaleBook.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VIcon,
  VTooltip,
})
